module.exports = __webpack_public_path__ + "static/divas4s-15f4b3fee5ff736a0081584a1500bb54.jpg";